import { ContentOverrideForRepairProperties, EFileType, MetadataSerialization } from '@adaptiva/metadata/common';
import { OverlayComponent } from '@adaptiva/widgets/overlay';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseContentAuthoringProperties } from '../base-content-authoring-properties';

@Component({
	standalone: false,
	selector: 'ada-content-override-for-repair-properties',
	templateUrl: './content-override-for-repair-properties.component.html',
	styleUrls: ['../base-content-authoring-properties/base-content-authoring-properties.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentOverrideForRepairPropertiesComponent extends BaseContentAuthoringProperties<ContentOverrideForRepairProperties> {
	@ViewChild('UploadOverlay')
	public uploadOverlay: OverlayComponent;

	public override fileType: EFileType = EFileType.REPAIR;

	public propertyConstructor: MetadataSerialization.Deserializable<ContentOverrideForRepairProperties> = ContentOverrideForRepairProperties;

}
